import { ChartContext } from '#components/chart/context/chartContext';
import { useContext } from 'react';
export const useChartContext = () => {
  const context = useContext(ChartContext);
  if (!context.data) {
    throw new Error("useChartContext must be used within a ChartProvider");
  }
  return context;
};